import React, { useState } from "react";
import ListViewActions from "../../shared/ListViewActions";
import { GenericTable } from "@shared/components/GenericTable";
import { TableAction } from "@shared/types/table";
import { useSearchParams } from "react-router-dom";
import { useValidationContext } from "@features/mx/validations/context";
import { exemptionsHeaders } from "@features/mx/validations/types";
import { useExemptionList, usePutEstimateReadings } from "@features/mx/validations/hooks";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { PAGE_SIZE } from "@shared/utils/constants";
import { toast } from "@shared/ui/use-toast";
import { downloadExcelSheet } from "@features/mx/validations/api";
import { useTableSort } from "@features/mx/utils/useTableSort";
import { logEvent } from "@amplitude/analytics-browser";
import { useToast } from "@shared/hooks/use-toast";

function ExemptionsList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchValue, setSearchValue] = useState("");
  const [selectedPremises, setSelectedPremises] = useState<string[]>([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const { sortArray, sortConfig, handleSort } = useTableSort();

  const { setViewMode, meterRunId, setValidatorId, readingId } =
    useValidationContext();
  const remoteUtilityId = useRemoteUtilityId();
  const {toast} = useToast()

  const { data: exemptionsList, refetch } = useExemptionList({
    remoteUtilityId,
    meterRunId,
    page: currentPage,
    limit: PAGE_SIZE,
    searchData: searchValue,
    premises: selectedPremises,
    readingId,
  });
  const {mutate: estimateReading} = usePutEstimateReadings(meterRunId);
  const actions: TableAction[] = [
    {
      label: "View",
      icon: "Eye",
      onClick: (row) => {
        // const hasValidatorIds =
        //   Array.isArray(row?.validator) && row.validator.length > 0;

        // if (hasValidatorIds) {
          const params = new URLSearchParams(searchParams);
          params.set("readingId", row?.id);
          setSearchParams(params);
          setViewMode("detail");
          setValidatorId(row.validator);
        // } else {
        //   toast({
        //     title: "Warning!",
        //     description: "Validator not assigned for this reading"
        //   })
        //   setValidatorId(null);
        // }
      },
      variant: "ghost",
    },
  ];

  const handleExport = async () => {
    try {
      const response = await downloadExcelSheet({
        remoteUtilityId,
        meterRunId,
        fileName: "break_view_readings",
        statusFilter: ["RCNT", "FAULTY"],
      });
      toast({
        title: "Export Initiated",
        description: response?.data?.message,
      });
      logEvent("MX Reading List Exported", {
        type: "Exemption Readings",
        count: exemptionsList?.count,
      });
    } catch (error) {
    }
  };

  const handleAutoCompleteReadings = () => {
    if (!selectedRows)
    {
      toast({
        title: "Select the reading(s) to estimate first"
      })
    }
    else {
      estimateReading({
        meterReadingIds: selectedRows
      }, {
      onSuccess: (res) => {
        toast({
          title: "Reading auto complete started.",
          description: "Readings validating in background. Please move to Pass tab to view the result"
        })
      }
      })
    }
  }

  const pagination = {
    currentPage,
    totalPages: Math.ceil((exemptionsList?.count || 0) / PAGE_SIZE),
    totalItems: exemptionsList?.count || 0,
    itemsPerPage: PAGE_SIZE,
    startItem: (currentPage - 1) * PAGE_SIZE + 1,
    endItem: Math.min(currentPage * PAGE_SIZE, exemptionsList?.count || 0),
  };

  return (
    <div className="space-y-4">
      <ListViewActions
        onExportClick={handleExport}
        onSearch={(val) => setSearchValue(val)}
        onRouteChange={(val) => setSelectedPremises(val)}
        onAutoComplete={handleAutoCompleteReadings}
      />
      {exemptionsList?.results && (
        <GenericTable
          data={exemptionsList.results}
          columns={exemptionsHeaders}
          rowKey="id"
          selectable={true}
          selectedRows={selectedRows}
          onSelectionChange={setSelectedRows}
          actions={actions}
          actionsType="icons"
          pagination={pagination}
          onPageChange={setCurrentPage}
          sortConfig={sortConfig}
          onSort={handleSort}
          emptyMessage="No readings found"
        />
      )}
    </div>
  );
}

export default ExemptionsList;
